<template>
  <div><slot v-if="ready" v-bind:height="height" v-bind:gap="gap" v-bind:width="width"></slot></div>
</template>

<script>
import { O3DG2, getScreen, getID } from '../../Reusable/O3DG2'
// import { LoadingManager } from '../../Reusable/LoadingManager'
import { loadTexture } from '../../Reusable/loadTexture'
import { ImageMaterial } from './ImageMaterial'

import { PlaneBufferGeometry, Mesh, DoubleSide, Vector3, Object3D } from 'three'

export default {
  props: {
    useRTT: {
      default: false
    },
    layout: {
      default: () => getID()
    },
    idx: {},
    image: {
    }
  },
  mixins: [O3DG2],
  data () {
    return {
      vm: this,
      ready: false,
      width: 0,
      height: 0,
      tmo3: new Object3D(),
      tmo3btm: new Vector3(),
      tm3: new Vector3(),
      screen: false
    }
  },
  methods: {
    setup () {
      let loadImg = async () => {
        let texture = await loadTexture(this.image)
        this.ready = true
        let image = texture.image
        let aspect = image.width / image.height
        let aspectR = image.height / image.width

        this.onResize(() => {
          this.screen = getScreen({ camera: this.ctx.camera, depth: this.tm3.setFromMatrixPosition(this.o3d.matrixWorld).z })
          let { width, height } = this.screen
          if (height < width) {
            let halfScreenHeight = height * 0.5
            let halfImageHeight = height * 0.5
            let gap = halfScreenHeight - halfImageHeight
            mesh.geometry = new PlaneBufferGeometry(height * aspect, height, 62, 2)
            mesh.geometry.translate(0, gap, 0)
            this.gap = gap
            this.height = height * -1
            this.width = height * aspect
          } else {
            let halfScreenHeight = height * 0.5
            let halfImageHeight = width * aspectR * 0.5
            let gap = halfScreenHeight - halfImageHeight
            mesh.geometry = new PlaneBufferGeometry(width, width * aspectR, 62, 2)
            mesh.geometry.translate(0, gap, 0)
            this.gap = gap
            this.height = width * aspectR * -1
            this.width = width
          }

          if (this.ctx.doLayout) {
            this.ctx.doLayout()
          }
        })
        return texture
      }

      // let getImg = () => {
      //   let tex = new TextureLoader(LoadingManager).load(this.image, (texture) => {
      //     this.ready = true
      //     let image = texture.image
      //     let aspect = image.width / image.height
      //     let aspectR = image.height / image.width

      //     this.onResize(() => {
      //       this.screen = getScreen({ camera: this.ctx.camera, depth: this.tm3.setFromMatrixPosition(this.o3d.matrixWorld).z })
      //       let { width, height } = this.screen
      //       if (height < width) {
      //         let halfScreenHeight = height * 0.5
      //         let halfImageHeight = height * 0.5
      //         let gap = halfScreenHeight - halfImageHeight
      //         mesh.geometry = new PlaneBufferGeometry(height * aspect, height, 62, 2)
      //         mesh.geometry.translate(0, gap, 0)
      //         this.height = height * -1
      //       } else {
      //         let halfScreenHeight = height * 0.5
      //         let halfImageHeight = width * aspectR * 0.5
      //         let gap = halfScreenHeight - halfImageHeight
      //         mesh.geometry = new PlaneBufferGeometry(width, width * aspectR, 62, 2)
      //         mesh.geometry.translate(0, gap, 0)
      //         this.height = width * aspectR * -1
      //       }

      //       if (this.ctx.doLayout) {
      //         this.ctx.doLayout()
      //       }
      //     })
      //   })
      //   return tex
      // }

      let mat = new ImageMaterial({ side: DoubleSide })
      loadImg()
        .then((tex) => {
          mat.image = tex
        })

      // mat.image = getImg()
      let mesh = new Mesh(undefined, mat)

      this.onLoop(() => {
        mat.time = window.performance.now() * 0.001
        // mat.velocity = this.ctx.vs.value / this.ctx.vs.limit.y
        mat.velocity = this.ctx.vs.diff

        // console.log(this.ctx.vs.diff)
      })

      // mesh.userData.noHover = true
      // this.ctx.rayplay.add(mesh, () => {
      //   this.$emit('clicker')
      // })

      this.onClean(() => {
        this.ctx.rayplay.remove(mesh)
      })

      // this.onLoop(() => {
      //   mesh.rotation.x += 0.01
      // })

      this.$watch('image', () => {
        // mat.map = getImg()
        loadImg()
          .then((tex) => {
            mat.image = tex
          })
      })

      this.o3d.add(mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>